import React, { useContext } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import { Modal } from "@lib/modal";
import ModalBody from "./ModalBody";
import ModalFooter from "./ModalFooter";

import { MyBetsStoreContext } from "@state/context/my-bets/MyBetsStoreContext";

export default observer(function AutosellConfirmationModal() {
	const { t } = useTranslation("mybets");

	const store = useContext(MyBetsStoreContext);

	if (
		!WEBPACK_IS_AUTOCASHOUT_ENABLED ||
		!store?.cashoutStore.isAutosellModalOpen
	) {
		return null;
	}

	return (
		<Modal>
			<div id="myBetsAutosellConfirmation" className="popup">
				<div className="popup__card">
					<div className="popup__header">
						{t("mybets:CASHOUT.AUTO_CASHOUT_HEADER_TITLE")}
					</div>
					<div className="popup__body">
						<ModalBody />
					</div>
					<div className="popup__footer">
						<ModalFooter />
					</div>
				</div>
			</div>
		</Modal>
	);
});
